<template>
    <modalComponent show="show" modalLarge="true">
        <div class="modal-content ">
            <div class="modal-header">
                <h6 class="modal-title m-0" id="exampleModalDefaultLabel">Department</h6>
                <button type="button" class="close" v-on:click="close()"><span
                        aria-hidden="true">&times;</span></button>
            </div>
            <div class="modal-body">

                <div class="form-group ">
                    <label>Name</label>
                    <input type="text" class="form-control" v-model="reports.name">
                </div>
                <div class="form-group ">
                    <label>Description</label>
                    <input type="text" class="form-control" v-model="reports.description">
                </div>
                <div class="form-group ">
                    <label>Image</label>
                    <input type="file" class="form-control" ref="imgupload1" accept="image/*" @change="onFileChange">

                    <!-- Show the uploaded image preview if imageName has a value -->
                    <div v-if="reports.id == '00000000-0000-0000-0000-000000000000'">
                        <img :src="reports.imagePath" alt="Image" class="img-thumbnail mt-2"
                            style="max-width: 200px;">
                    </div>
                    <div v-if="reports.id != '00000000-0000-0000-0000-000000000000'">
                        <img :src="'https://redevz.com' + reports.imagePath" :alt="reports.imageName" class="img-thumbnail mt-2"
                            style="max-width: 200px;">
                    </div>
                </div>

                <div class="form-group ">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" name="checkbox" v-model="reports.isActive"> Active
                        </label>
                    </div>
                </div>
                <div class="submit-section text-center">
                    <button type="submit" class="btn btn-primary submit-btn" @click="Savedepartment()">Submit</button>
                    <button type="button" class="btn btn-secondary submit-btn" v-on:click="close()">Cancel</button>
                </div>
            </div>

            <loading v-model:active="loading" :can-cancel="false" :is-full-page="true"></loading>
        </div>
    </modalComponent>
</template>
<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import useVuelidate from '@vuelidate/core';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
    name: "addReportsModel",
    props: ['show', 'reportsModel', 'type'],
    components: {
        Loading
    },
    setup() {
        return { v$: useVuelidate() }
    },
    data: function () {
        return {

            render: 0,
            loading: false,
            reports: this.reportsModel,
            isRequest: false,
        }
    },
    validations() {
        return {

        }
    },
    methods: {
        close: function () {
            this.$emit('close');
        },
        Savedepartment: async function () {
            var root = this;
            this.loading = true;
            var token = '';
            if (token == '') {
                token = localStorage.getItem('token');
            }
           
            await this.uploadImage();

           if(this.isRequest){
            await this.$https.post('/Report/SaveReports', this.reports, { headers: { "Authorization": `Bearer ${token}` } })
                .then(function (response) {
                    if (response.data.isSuccess == true) {
                        root.$swal.fire({
                            title: 'Saved',
                            text: response.data.commonMessage,
                            type: 'success',
                            icon: 'success',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });

                        root.close();

                    }
                    else {
                        root.$swal.fire({
                            title: 'Error!',
                            text: response.data.commonMessage,
                            type: 'error',
                            icon: 'error',
                            showConfirmButton: false,
                            timer: 1500,
                            timerProgressBar: true,
                        });
                    }
                })
                .catch(error => {
                    console.log(error)
                    root.$swal.fire(
                        {
                            icon: 'error',
                            title: 'Something Went Wrong!',
                            text: error.response.data,

                            showConfirmButton: false,
                            timer: 5000,
                            timerProgressBar: true,
                        });

                    root.loading = false
                })
                .finally(() => root.loading = false);
           }
           else
           {
            root.$swal.fire({
                title: 'Error!',
                text: 'Something went wrong!',
                type: 'error',
                icon: 'error',
                showConfirmButton: false,
                timer: 1500,
                timerProgressBar: true,
            });
            root.loading = false;
           }
        },
        onFileChange(event) {
            const file = event.target.files[0];

            if (file) {
                // Validate if the file is an image
                if (!file.type.startsWith('image/')) {
                    this.$swal.fire({
                        title: 'Invalid File',
                        text: 'Please select a valid image file!',
                        icon: 'error',
                        timer: 2000,
                        showConfirmButton: false,
                        timerProgressBar: true,
                    });
                    return;
                }

                this.reports.imageName = file;
                this.reports.imagePath = URL.createObjectURL(file); // Preview image before upload
            }
        },
        uploadImage() {
           
            var root = this;
            var file = this.$refs.imgupload1.files;

            this.filePath = null;
            var fileData = new FormData();
            // convert file into FormData object
            for (var k = 0; k < file.length; k++) {
                fileData.append("files", file[k]);
            }
            root.reports.imageName = file[0].name;

            this.$https.post('/Company/UploadFilesAsync', fileData)
                .then(function (response) {
                    if (response.data != null) {
                        root.reports.imagePath = response.data;
                        root.isRequest = true
                    }
                });
        },
    },
    mounted: function () {
        if (this.reports.id == '00000000-0000-0000-0000-000000000000') {
            this.reports.userId = localStorage.getItem("UserID");
        }
        if (this.reports.id != '00000000-0000-0000-0000-000000000000') {
            this.reports.userId = localStorage.getItem("UserID");
        }
    }
}
</script>